"use client";

import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function StartYourProject() {
  const contactDetails = [{
    icon: Phone,
    label: "Office Number",
    value: "615-369-6940"
  }, {
    icon: MapPin,
    label: "Office Address",
    value: "109 Jefferson Street North, Suite 8E Huntsville, AL 35801"
  }];
  return <section id="contact-our-team" className="bg-background text-foreground py-16 lg:py-24 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          
          <div className="lg:col-span-5 flex flex-col space-y-12">
            <div>
              <h2 className="font-default text-4xl md:text-5xl font-extrabold text-foreground mb-8 uppercase tracking-tighter">
                Contact <span className="text-primary">Us</span>
              </h2>
              
              <div className="space-y-6">
                {contactDetails.map((item, i) => <div key={i} data-index={i} className="flex items-start gap-4 group">
                    <div className="p-3 bg-secondary border border-border group-hover:border-primary transition-colors rounded-sm">
                      <item.icon className="size-6 text-primary" />
                    </div>
                    <div className="pt-1">
                      <h4 className="font-default text-sm font-bold text-muted-foreground uppercase tracking-widest">
                        {item.label}
                      </h4>
                      <p className="text-foreground mt-1 font-mono text-lg">
                        {item.icon === Mail ? <Link to={`mailto:${item.value}`} className="hover:text-primary transition-colors underline decoration-primary/30 underline-offset-4">
                            {item.value}
                          </Link> : item.value || "Not provided"}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}